<template>
  <transition name="confirm">
    <div class="modal" v-if="visible">
      <div class="confirm" :class="type" >
        <div class="confirm-header">
          <div class="confirm-header-title">
            <span>提示</span>
          </div>
          <button type="button" aria-label="Close" class="confirm-headerBtn" @click="visible=false">
            <i class="el-message-box__close el-icon-close"></i>
          </button>
        </div>
        <div class="confirm-content">
          <!-- <img class="Icon" v-if="type === 'success'"  src="../../../static/icon/Icons_Operate_prompt@2x.png" alt=""> -->
          <div class="confirm-content-icon">
            <img class="Icon" v-if="type === 'warning'" src="../../assets/images/newimg/tips.png" alt="">
          </div>
          <div class="confirm-content-message">
            {{content}}
          </div>
        </div>
        <div class="confirm-buttonArea">
          <span class="button preservation" @click="visible=false;operation1()">{{button1}}</span>
          <span class="button closeBtn" @click="visible=false;operation2()">{{button2}}</span>
          <span class="button cancel" @click="visible=false;operation3()">{{button3}}</span>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'MyConfirm',
  data () {
    return {
      content: '',
      visible: false,
      type: 'warning',
      button1: '保存并关闭',
      button2: '直接关闭',
      button3: '取消关闭'
    }
  },
  mounted () {
  },
  methods: {
    operation(val){
      if(val == '保存并关闭'){
      }else if(val == '直接关闭'){
      }else if(val == '取消关闭'){
      }
    }
  }
}
</script>
<style scoped>
  @keyframes fadeInDown{
    0%{opacity:0;-webkit-transform:translate3d(0,-1%,0);transform:translate3d(0,-1%,0)}
    to{opacity:1;-webkit-transform:translateZ(0);transform:translateZ(0)}}
  @keyframes fadeOutUp{
    0%{opacity:1}
    to{opacity:0;-webkit-transform:translate3d(0,-1%,0);transform:translate3d(0,-1%,0)}}
  .confirm-enter-active {
    animation: fadeInDown 0.3s;
  }
  .confirm-leave-active {
    animation: fadeOutUp 0.3s;
  }
  .modal{
    z-index: 10000;
    background-color: rgba(0,0,0, .5);
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    text-align: center;
  }
  .confirm{
    padding: 14px;
    text-align: left;
    border-radius: 4px;
    background-color: #fff;
    box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    border: 1px solid #ebeef5;
    width: 420px;
    vertical-align: middle;
    overflow: hidden;
    font-size: 18px;
    position: relative;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
  .confirm-header{
    height: 42px;
    padding: 0;
  }
  .confirm-header-title{
    float: left;
    line-height: unset;
    padding-left: 0;
    margin-bottom: 0;
    font-size: 18px;
    color: #333;
  }
  .confirm-headerBtn{
    float: right;
    line-height: unset;
    right: 0;
    top: 2px;
    background: url(../../assets/images/newimg/close.png) no-repeat;
    font-size: 0;
    width: 14px;
    height: 14px;
    border: none;
    cursor: pointer;
    padding: 0;
  }
  .el-icon-close{
      font-size: 0;
  }
  .confirm-content{
    padding: 0;
    margin-bottom: 14px;
    color: #666;
    font-size: 14px;
    height: 24px;
    position: relative;
    line-height: 24px;
  }
  .confirm-content-icon{
    width: 20px;
    height: 20px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 2px;
  }
  .Icon{
    width: 100%;
    height: 100%;
    float: left;
  }
  .confirm-content-message{
    padding-left: 36px;
    padding-right: 12px;
    margin: 0;
    font-size: 14px;
    line-height: 24px;
  }
  .confirm-buttonArea{
    padding: 0;
    height: 30px;
    float: right;
  }
  .confirm-buttonArea .button{
    border-radius: 4px;
    width: 88px;
    height: 30px;
    font-size: 14px;
    padding: 6px 15px;
    float: left;
    margin-left: 8px;
    cursor: pointer;
    text-align: center;
  }
  .preservation{
    width: 110px !important;
    color: #fff;
    border: 1px solid #2174ff;
    background-color: #2174ff;
  }
  .preservation:hover{
    border: 1px solid #ffa556;
    background-color: #ffa556;
  }
  .closeBtn{
    color: #666;
    border: 1px solid #ccc;
    background-color: #fff;
  }
  .cancel{
    color: #666;
    border: 1px solid #ccc;
    background-color: #fff;
  }
  .closeBtn:hover{
    background-color: #EEEEEE;
  }
  .cancel:hover{
    background-color: #EEEEEE;
  }
</style>


// WEBPACK FOOTER //
// src/common/Confirm/confirm.vue